export const UnitConverter = (amt: number): String => {
  if (Math.abs(amt) >= 1_000_000_000_000) {
    return (
      (amt / 1_000_000_000_000)
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1') + 'T'
    );
  } else if (Math.abs(amt) >= 1_000_000_000) {
    return (
      (amt / 1_000_000_000)
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1') + 'B'
    );
  } else if (Math.abs(amt) >= 1_000_000) {
    return (
      (amt / 1_000_000)
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1') + 'M'
    );
  } else if (Math.abs(amt) >= 1_000) {
    return (
      (amt / 1_000)
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1') + 'K'
    );
  } else {
    return amt.toString();
  }
};

export const CalculateProfitLossPercent = (
  profitLoss: number,
  moneyIn: number
): number => {
  const percentProfitLoss = (profitLoss / moneyIn) * 100;

  return parseFloat(percentProfitLoss.toFixed(2)); // Rounded to 2 decimal places
};

export const FormatMoneyToDisplay = (amount: number): string => {
  return `${amount < 0 ? '- ' : ''}$${Math.abs(amount)
    .toFixed(2)
    .toLocaleString()}`;
};

export const formatLineGraphValue = (value: number): string =>
  Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'SGD',
    maximumSignificantDigits: 3,
    notation: 'compact',
  }).format(value);
